import { render, staticRenderFns } from "./chateau-marquis-dalesme.vue?vue&type=template&id=694c319f&scoped=true"
import script from "./chateau-marquis-dalesme.vue?vue&type=script&lang=js"
export * from "./chateau-marquis-dalesme.vue?vue&type=script&lang=js"
import style0 from "./chateau-marquis-dalesme.vue?vue&type=style&index=0&id=694c319f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c319f",
  null
  
)

export default component.exports